// import AddPublisher from "addPublisher.css" 
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// images
import impression from "../../assets/images/group_1.png";
import ctr from "../../assets/images/CTR.png";
import earningImg from "../../assets/images/earning.png";  
import date from "../../assets/images/date_1.png";
import axios from "axios";
// import { useNavigate } from "react-router-dom";
const CreatePublisher = () => {
  const [formData, setFormData] = useState({
    account_name: "",
    username: "",
    password: "",
    contact_person:"",
    email: "",
    phone: "",
    company_name: "",
    brand_name: "",
    address: "",
    country: "",
    pricing_model: "0", // Default value for dropdown
    fixed_fee: "0",
    revenue_sharing: "",
    website_url: "",
    status: "0",
    show_request:"1",
    show_impression:"1",
    show_ctr:"1",
    show_pubRev:"1",
    show_pub_eCPM:"1"
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setMessage("");

	const requestData = {
		acc_user_id: "1",
		created_by: "1",
		account_name: formData.account_name,
		username: formData.username,
		password: formData.password,
    contact_person:formData.contact_person,
		email: formData.email,
		phone: formData.phone,
		company_name: formData.company_name,
		brand_name: formData.brand_name,
		address: formData.address,
		country: formData.country,
		pricing_model: String(formData.pricing_model),
		fixed_fee: formData.fixed_fee,
		revenue_sharing: formData.revenue_sharing,
		website_url: formData.website_url,
		status: formData.status,
    show_request:formData.show_request, 
    show_impression:formData.show_impression, 
    show_ctr:formData.show_ctr, 
    show_pubRev:formData.show_pubRev, 
    show_pub_eCPM:formData.show_pub_eCPM, 
	  };

    try {
      const token = localStorage.getItem("token"); // Get token from storage

      const response = await axios.post(
		  `${process.env.REACT_APP_API_BASE_URL}/api/admin/createPublisher`,
		  requestData,
		{
		  headers: {
		  Authorization: `Bearer ${token}`,
		  "Content-Type": "application/json",
		  Accept: "application/json",
		  },
		}
		);      
      // setTimeout(() => {
      //   setMessage("");        
      // }, 2000);
      if (response.status === 201) {
        setMessage("Publisher created successfully!");
        alert("Publisher created successfully!")
        navigate('/publisher-list');
        // setTimeout(() => {
        // }, 2000);
        // alert("Publisher created successfully!");
        // Reset the form fields
        // setFormData(requestData);
        // Hide the success message after 3 seconds
        // setTimeout(() => {
        //   setMessage("");
        // }, 3000);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        console.error("Unauthorized! Token might be expired.");
        localStorage.removeItem("token");
        navigate("/");
      } else {
        console.error("Error fetching data:", error);
      }
      if (error.response?.data?.errors) {
        setErrors(error.response.data.errors);
      } else {
        setMessage("Something went wrong. Please try again.");
      }
    }
  };

  return (
    <section className="createPub mainContainer">
          <div className="container mt-4">
      <h4>Create Publisher</h4>
      {message && <p className="alert alert-info">{message}</p>}
      <form onSubmit={handleSubmit} autocomplete="new-password">
        <div className="row">
          <div className="col-md-4">
            <label>Account Name:</label>
            <input
              type="text"
              name="account_name"
              className="form-control"
              value={formData.account_name}
              onChange={handleChange}
              autocomplete="off" />
            {errors.account_name && <p className="text-danger">{errors.account_name[0]}</p>}
          </div>

          <div className="col-md-4">
            <label>Username:</label>
            <input
              type="text"
              name="username"
              className="form-control"
              value={formData.username}
              onChange={handleChange}
              autocomplete="off" />
            {errors.username && <p className="text-danger">{errors.username[0]}</p>}
          </div>
          <div className="col-md-4">
            <label>Contact Person:</label>
            <input
              type="text"
              name="contact_person"
              className="form-control"
              value={formData.contact_person}
              onChange={handleChange} 
              autocomplete="new-password" />
            {errors.username && <p className="text-danger">{errors.username[0]}</p>}
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-6">
            <label>Password:</label>
            <input
              type="password"
              name="password"
              className="form-control"
              value={formData.password}
              onChange={handleChange}
              autocomplete="off" />
          </div>
          <div className="col-md-6">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
              autocomplete="off" />
            {errors.email && <p className="text-danger">{errors.email[0]}</p>}
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-6">
            <label>Phone:</label>
            <input
              type="text"
              name="phone"
              className="form-control"
              value={formData.phone}
              onChange={handleChange}
              autocomplete="off" />
          </div>

          <div className="col-md-6">
            <label>Company Name:</label>
            <input
              type="text"
              name="company_name"
              className="form-control"
              value={formData.company_name}
              onChange={handleChange}
              autocomplete="off" />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-6">
            <label>Brand Name:</label>
            <input
              type="text"
              name="brand_name"
              className="form-control"
              value={formData.brand_name}
              onChange={handleChange}
              autocomplete="off" />
          </div>

          <div className="col-md-6">
            <label>Address:</label>
            <input
              type="text"
              name="address"
              className="form-control"
              value={formData.address}
              onChange={handleChange}
              autocomplete="off" />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-6">
            <label>Country:</label>
            <input
              type="text"
              name="country"
              className="form-control"
              value={formData.country}
              onChange={handleChange}
              autocomplete="off" />
          </div>

          <div className="col-md-6">
            <label>Pricing Model:</label>
            <select
              name="pricing_model"
              className="form-control"
              value={formData.pricing_model}
              onChange={handleChange}
            >
              <option value="1">Revenue Sharing</option>
              <option value="0">Fixed Price</option>
              <option value="2">Both</option>
            </select>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-6">
            <label>Fixed Fee:</label>
            <input
              type="number"
              name="fixed_fee"
              className="form-control"
              value={formData.fixed_fee}
              onChange={handleChange}
              autocomplete="off" />
          </div>

          <div className="col-md-6">
            <label>Revenue Sharing (%):</label>
            <input
              type="number"
              name="revenue_sharing"
              className="form-control"
              value={formData.revenue_sharing}
              onChange={handleChange}
              autocomplete="off" />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-6">
            <label>Website URL:</label>
            <input
              type="text"
              name="website_url"
              className="form-control"
              value={formData.website_url}
              onChange={handleChange}
              autocomplete="off" />
            {errors.website_url && <p className="text-danger">{errors.website_url[0]}</p>}
          </div>

          <div className="col-md-6">
            <label>Status:</label>
            <select
              name="status"
              className="form-control"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="1">Inactive</option>
              <option value="0">Active</option>
            </select>
          </div>
        </div>
      <div className="row">
        <h4 className="mt-5">Reporting Options</h4>
        <div className="col-md-4">
            <label>Show Request:</label>
            <select
              name="show_request"
              className="form-control"
              value={formData.show_request}
              onChange={handleChange}>
              <option value="1">Yes</option>
              <option value="0">No</option>
              </select>
            {errors.website_url && <p className="text-danger">{errors.website_url[0]}</p>}
          </div>
          <div className="col-md-4">
            <label>Show Impression </label>
            <select
              name="show_impression"
              className="form-control"
              value={formData.show_impression}
              onChange={handleChange}
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
          <div className="col-md-4">
            <label>Show CTR </label>
            <select
              name="show_ctr"
              className="form-control"
              value={formData.show_ctr}
              onChange={handleChange}
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
          <div className="col-md-4">
            <label>Show PubRev</label>
            <select
              name="show_pubRev"
              className="form-control"
              value={formData.show_pubRev}
              onChange={handleChange}
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
          <div className="col-md-4">
            <label>Show PubeCPM</label>
            <select
              name="show_pub_eCPM"
              className="form-control"
              value={formData.show_pub_eCPM}
              onChange={handleChange}
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
      </div>
        <button type="submit" className="btn btn-primary mt-4">Submit</button>
      </form>
    </div>
    </section>

  );
};

export default CreatePublisher;
